module.exports = __webpack_public_path__ + "img/teenager-icon.cb9382e7.svg";